<!--begin::Header container-->
<div class="app-container" id="kt_app_header_container" [ngClass]="headerContainerCssClass">
	<!-- hamburguer menu and logo - RWD mobile case -->
	<ng-container *ngIf="appSidebarDisplay">
		<div class="d-flex align-items-center d-lg-none ms-n2 me-2" title="Show sidebar menu">
			<div class="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_sidebar_mobile_toggle">
				<app-keenicon name="abstract-14" class="fs-1"></app-keenicon>
			</div>
		</div>
		<div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
			<a routerLink="/" class="d-lg-none">
				<img alt="Logo" src="/assets/media/icons/spotside.svg" class="h-30px" />
			</a>
		</div>
	</ng-container>

	<!-- Superior menu -->
	<div class="d-flex align-items-stretch justify-content-end flex-lg-grow-1" id="kt_app_header_wrapper">
		<app-navbar class="app-navbar flex-shrink-0" [appHeaderDefaulMenuDisplay]="appHeaderDefaulMenuDisplay" [isRtl]="false"></app-navbar>
	</div>
</div>
<!--end::Header container-->
